import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'antd';
import { isObject } from 'lodash';

import TableWrapper from 'src/FBFormComponents/TableWrapper';
import { $t } from 'src/tools';
import columnConfig from './column';
import { isProdTest } from 'src/utils';
import { isMC } from 'src/utils/env'

class StatisticsManage extends Component {
  async componentDidMount() {
    const { dispatch, dailyReportState, reportList } = this.props;

    if (!dailyReportState[this.type]) {
      await dispatch({ type: 'dailyReport/initState', payload: reportList });
    }

    const { hasConfig } = this.props.dailyReportState[this.type];

    const ids = (this.props.reportList || []).map((v) => v.id);

    if (!hasConfig && ids.includes(Number(this.type))) {
      dispatch({ type: 'dailyReport/fetchReportConfig', payload: { reportKey: this.type } });
    }
  }

  get type() {
    const { match, type } = this.props;
    return type || match?.params?.type || '';
  }

  render() {
    if (!this.type || !this.props?.dailyReportState?.[this.type]) {
      return <div/>;
    }
    const { dailyReportState } = this.props;
    const { loading, config, source, custom, reqId } = dailyReportState[this.type];
    return (
      <div style={{ margin: -15, marginBottom: -50 }}>
        <TableWrapper
          reqId={reqId}
          custom={custom}
          source={source}
          type={this.type}
          loading={loading}
          rowSelection={null}
          basicConfig={config}
          columnConfig={columnConfig}
          onChange={this.handleChange}
          tableOption={{
            rowKey: (r, i) =>
              [...Object.values(r), i]
                .map((v) => (v && isObject(v) ? v.name || v.value : v))
                .filter(Boolean)
                .join(','),
          }}
          onExport={isProdTest() ? undefined : this.handleExport}
        />
      </div>
    );
  }

  // 请求报表
  handleChange = async (val) => {
    const { dispatch, dailyReportState } = this.props;
    const { query } = dailyReportState[this.type];
    if (val) {
      dispatch({ type: 'dailyReport/setTypeState', payload: { query: val, reportKey: this.type } });
    }
    if (!isMC()) {
      await dispatch({
        type: 'dailyReport/fetchReportList',
        payload: { ...(val || query), reportKey: this.type },
      });
    }
  };
  // 导出
  handleExport = async (val) => {
    const { dispatch, dailyReportState } = this.props;
    const { query } = dailyReportState[this.type];

    const res = await dispatch({
      type: 'dailyReport/fetchExportList',
      payload: { ...(val || query), reportKey: this.type },
    });
    if (res) {
      Modal.info({
        title: $t('tip', 'Import'),
        content: $t('upload_tip34', 'Import'),
        okText: $t('good', 'Import'),
      });
    }
    return res;
  };
}

export default connect(({ dailyReportState, appState }) => ({
  dailyReportState,
  reportList: appState.reportList,
}))(StatisticsManage);
